import { apiInterface } from '@/api/interfaces'
import AbstractApi from '@/api/abstract'
import { reportsApiReq, reportsApiRes } from './interfaces'

class ReportsApi implements apiInterface.IReportsApi {
  ctx: AbstractApi

  constructor(ctx: AbstractApi) {
    this.ctx = ctx
  }

  getStatistics = async (name: string): Promise<reportsApiRes.IGetStatisticsRes> => {
    const res = await this.ctx.get<unknown, reportsApiRes.IGetStatisticsRes>(`/reports/${name}`)
    return res.data
  }

  createStatistics = async (
    name: string,
    params: reportsApiReq.ICreateStatisticsReq
  ): Promise<void> => {
    await this.ctx.post<reportsApiReq.ICreateStatisticsReq, void>(
      `/reports/${name}?start_date=${params.start_date}&end_date=${params.end_date}`,
      params
    )
  }

  getPresets = async (
    params: reportsApiReq.IGetPresetsReq = {}
  ): Promise<reportsApiRes.IGetPresetsRes> => {
    const res = await this.ctx.get<reportsApiReq.IGetPresetsReq, reportsApiRes.IGetPresetsRes>(
      '/reports/preset/',
      params
    )
    return res.data
  }

  addPresets = async (
    params: reportsApiReq.IAddPresetsReq
  ): Promise<reportsApiRes.IAddPresetsRes> => {
    const res = await this.ctx.post<reportsApiReq.IAddPresetsReq, reportsApiRes.IAddPresetsRes>(
      '/reports/preset/',
      params
    )
    return res.data
  }

  changePresets = async (
    id: number,
    params: reportsApiReq.IChangePresetsReq
  ): Promise<reportsApiRes.IChangePresetsRes> => {
    const res = await this.ctx.patch<
      reportsApiReq.IChangePresetsReq,
      reportsApiRes.IChangePresetsRes
    >(`/reports/preset/${id}/`, params)
    return res.data
  }

  deletePresets = async (id: number): Promise<void> => {
    await this.ctx.delete<unknown, void>(`/reports/preset/${id}/`)
  }
}

export default ReportsApi
